import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { VendorsReducer } from "../reducers/VendorsReducer";

const VendorsContext = createContext({
	state: VendorsReducer.getInitialState(),
	actions: VendorsReducer.actions,
});

export const useVendorsContext = () => useContext(VendorsContext);

export const VendorsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: VendorsReducer.getInitialState(),
		reducers: VendorsReducer.caseReducers,
	});
	return (
		<VendorsContext.Provider value={{ state, actions }}>
			{children}
		</VendorsContext.Provider>
	);
};
